import styled from "styled-components";

export const Container = styled.div`
  border-radius: 5px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const Title = styled.span`
  margin-bottom: 20px;
  font-family: Asap;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  color: #4b4b4b;
`;
